import { render, staticRenderFns } from "./PrintersSettings.vue?vue&type=template&id=7cb78bd5&scoped=true&"
import script from "./PrintersSettings.vue?vue&type=script&lang=js&"
export * from "./PrintersSettings.vue?vue&type=script&lang=js&"
import style0 from "./PrintersSettings.vue?vue&type=style&index=0&id=7cb78bd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb78bd5",
  null
  
)

export default component.exports